<template>
  <el-container>
    <el-main>
      <el-form ref="form" label-width="80px">
        <div v-for="(item, index) in schoolList" :key="index">
          <el-divider content-position="left">学习经历 {{index+1}}</el-divider>
          <el-form-item label="学校名称">
            <el-input @change="change($event, item, index)" v-model="item.school"></el-input>
          </el-form-item>
          <el-form-item label="学历">
            <el-select @change="change($event, item, index)" v-model="item.education" placeholder="选择学历">
              <el-option v-for="(val, key, index) in defaultInfo.education" :key="index" :label="val" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业">
            <el-input @change="change($event, item, index)" v-model="item.profession"></el-input>
          </el-form-item>
          <el-form-item label="在校时间">
            <el-date-picker
              @blur="change($event, item, index)"
              v-model="item.date"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="addSchool" icon="el-icon-plus">添加学习经历</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import $http from "../../../request.js";
import _ from "lodash";
export default {
  name: "school",
  created(){
    this.updateSchoolList(this.list);
  },
  computed:{
    ...mapState([
      "defaultInfo",
      "area"
    ])
  },
  props:{
    list:{
      type: Array,
      default:function(){
        return [];
      }
    }
  },
  watch:{
    list(list){
      this.updateSchoolList(list);
    }
  },
  data(){
    return {
      schoolList: [
        {
          school: "",
          date: "",
          education: "",
          profession: ""
        }
      ]
    };
  },
  methods:{
    updateSchoolList(list){
      this.schoolList = list.map(v=>{
        v.date = [
          v.start_date,
          v.end_date
        ];
        return v;
      });
    },
    addSchool(){
      this.schoolList = [
        ...this.schoolList,
        {
          school: "",
          date: "",
          education: "",
          profession: ""
        }
      ]
    },
    updateSchool(params) {
      let url = "/api/member/member_learning_experience/add";
      if(params.id) {
        url = "/api/member/member_learning_experience/edit";
      }
      $http.post(url, params)
        .then(res=>{
          if (res.data.code===1){
            this.$message({
              message: params.id?"修改成功":"新增成功",
              type: 'success'
            });
            this.$emit('success');
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
    },
    focus(index){
      this.activeIndex = index;
    },
    change(e, item, index) {
      this.schoolList[index] = item;
      const params = {
        id: item.id||'',
        school: item.school,
        start_date: item.date[0],
        end_date: item.date[1],
        education: item.education,
        profession: item.profession
      }
      let toupdate = true;
      _.forIn(params, (val, key)=>{
        if (!val&&key!=='id') {
          toupdate = false;
        }
        if (val=="") {
          delete params[key];
        }
      });
      if (toupdate) {
        this.updateSchool(params);
      }
    }
  }
};
</script>

<style lang="less">
  
</style>

